import React from 'react';
import LoadingSpinner from '@/components/ui/loader/LoadingSpinner';

interface RouteLoaderProps {
    children: React.ReactNode;
}

export const RouteLoader: React.FC<RouteLoaderProps> = ({ children }) => {
    return (
        <React.Suspense
            fallback={
                <div className="min-h-screen flex items-center justify-center">
                    <LoadingSpinner size="lg" />
                </div>
            }
        >
            {children}
        </React.Suspense>
    );
};